import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'webchat-status',
  imports: [CommonModule],
  templateUrl: './webchat-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./webchat-status.component.scss'],
})
export class WebchatStatusComponent {
  size = input(8);
}
